module.exports = __webpack_public_path__ + "assets/images/hypertension_y.b9213219.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/hypertension_y.png
// module id = 742
// module chunks = 1